import { useTranslate } from "@growtherapy/i18n";
import { Alert } from "@growtherapy/sprout-ui";

export function ProviderReadyToSeeYouCard({
  countdown,
}: {
  countdown?: string | null;
}) {
  const t = useTranslate();
  return (
    countdown && (
      <Alert
        heading={t("telehealth-core:waitingRoom.yourProviderIsReadyToSeeYou")}
        use="info"
      >
        {t("telehealth-core:waitingRoom.automaticallyTransferringInSeconds", {
          countdown,
        })}
      </Alert>
    )
  );
}
